import {Grid, Switch, Typography} from '@yandex-delivery/blocks'
import {useController, useFormContext} from '@yandex-delivery/form'
import React from 'react'

import {i18n} from 'src/shared/config'
import {OrderEventGoal, useFormUserEventHandler} from 'src/shared/hooks'

import * as classes from './BusinessToggle.classes'

type Props = {
  name: string
}

export function BusinessToggle({name}: Props) {
  const {control} = useFormContext()
  const {field, fieldState} = useController({control, name, defaultValue: false})
  const handleReachGoal = useFormUserEventHandler()

  function handleChange(value: boolean) {
    field.onChange(value)
    handleReachGoal(OrderEventGoal.BusinessSwitchClick)
  }

  return (
    <Grid alignItems="center" container>
      <Grid item>
        <Typography className={classes.caption} group="normal" thickness="bold" variant="caption1">
          {i18n('form.ntl.field.is-business', 'Бизнес')}
        </Typography>
      </Grid>
      <Grid className={classes.toggle} item>
        <Switch
          data-e2e="business-switch"
          error={fieldState.invalid}
          on={field.value}
          onChange={handleChange}
          size="m"
        />
      </Grid>
    </Grid>
  )
}
